import 'slick-carousel';
import { isMobile } from '../utilities/check-device-resolution';

const defaultSlider = '.js-slider';
const mobileOnlySlider = '.js-slider-mobile';

/**
 * Init slider
 *
 * @param {HTML element} $slider
 * @param {String} sliderType
 * @param {Integer} index [optional]
 * @return {Void}
 */

export const initSlider = (slider, sliderType) => {
	let config = {};

	const prevArrow = $(slider).find('.slider__prev')[0];
	const nextArrow = $(slider).find('.slider__next')[0];
	const autoplay = $(slider).data().autoplay;
	const autoplaySpeed = autoplay ? $(slider).data().autoplaySpeed: 0;
	const hasArrows = !$(slider).data().nav ? $(slider).data().nav: true;

	if (slider.find('.slider__slide').length <= 1) {
		slider.addClass('is-inactive');
	}

	if (sliderType === 'default') {
		config = {
			prevArrow: prevArrow,
			nextArrow: nextArrow,
			slidesToScroll: 1,
			speed: 400,
			infinite: false,
			autoplay: autoplay,
			autoplaySpeed: autoplaySpeed,
			arrows: hasArrows
		};
	}

	$(slider)
		.find('.slider__slides')
		.not('.slick-initialized')
		.slick(config);
}

const initSliderPhone = () => {
	const $slider = $('.js-slider-phone');
	const $slides = $slider.find('.slider__slides');
	const $slide = $('.js-slider-phone .slider__slide');

	$slide.each((index, element) => {
		const width = $(element).outerWidth();
		const translateValue = (width + 40) * index;

		$(element).css({
      transform: `translateX(${translateValue}px)`
    });
	})

	setInterval(handleSlides, 2300);

	function handleSlides() {
		$('.js-slider-phone .slider__slide').each((index, element) => {
			const $this = $(element);
			const width = $this.outerWidth();
			let spacing = 40;

			if (isMobile()) {
				spacing = 18;
			}

			if (index === 0) {
				// Handle animation
				const $clone = $this.clone();
				const value = ($slide.length - 0.4) * (width + spacing)

				$clone.css({
		      transform: `translateX(${value}px)`,
		      opacity: 0
				})

				$this.addClass('hide');

				setTimeout(() => {
					$this.remove();

					setTimeout(() => {
						$slides.append($clone);

						const $newSlide = $slides.find('.slider__slide:last-child');

						setTimeout(() => {
							$newSlide.css({
					      transform: `translateX(${($slide.length - 1) * (width + spacing)}px)`,
					      opacity: ''
					    });
						}, 100);
					});
				}, 600)
			} else {
				const translateValue = (width + spacing) * (index - 1);

				$this.css({
		      transform: `translateX(${translateValue}px)`,
		      transitionDelay: `${0.12 * (index - 1)}s`
				})
			}
		});
	}
}

const initSliderNotifications = () => {
	const $slider = $('.js-slider-notifications');

	setInterval(handleSlides, 3250);

	function handleSlides() {
		const $slide = $slider.find('.slider__slide').first();

		$slide.addClass('is-active');

		setTimeout(() => {
			$slide.removeClass('is-active').addClass('hide');
			const $clone = $slide.clone();
			$clone.removeClass('hide is-active');
			$slider.append($clone);

			setTimeout(() => {
				$slide.remove();
			}, 1000);
		}, 2200);
	}
}

/**
 * Check for mobile only sliders
 */

const checkForMobileOnlySliders = () => {
	$(mobileOnlySlider).each(function(index, el) {
		const sliderBody = $(el).find('.slider__slides');
		const isInitialized = $(sliderBody).hasClass('slick-initialized');

		if (!isInitialized && isMobile()) {
			initSlider($(el), 'default');
		} else if (isInitialized && !isMobile()) {
			$(sliderBody).slick("unslick");
		}
	});
}

/**
 * Init sliders
 */

$(defaultSlider).each(function(index, el) {
	initSlider($(el), 'default')
});

initSliderPhone();
initSliderNotifications();
checkForMobileOnlySliders();

/**
 * Window resize trigger
 *
 * @return {Void}
 */

$(window).on('resize', function(evt) {
	evt.preventDefault();
	checkForMobileOnlySliders();
});
